import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import { Url } from '@wix/da-url';
import EllipsisIcon from '@wix/da-shared-react/pkg/Icons/Ellipsis';
import { givableBadgeItemsHash } from '../../../../UserWidgets/MyBadges/Badges/BadgeGifts/givableBadgeItems';
import { ProfileOwnerGiveState } from '../../../../../../types/profileOwner';

import s from './MoreActionsDropdownMobile.scss';

export interface Props {
  className?: string;
  iconClassName?: string;
  isOwner?: boolean;
  profileOwnerUser: PapiUser;
  giveState: ProfileOwnerGiveState;
  isSticky: boolean;
  pushBadgeModal: (
    name: 'llama' | 'cake',
    userId: number,
    title: string,
    onBadgeSent: () => void
  ) => void;
  pushPointsModal: (username: string, title: string) => void;
  onLlamaBadgeSent: () => void;
  onCakeBadgeSent: () => void;
  initGiveState: () => void;
}

export class MoreActionsDropdownMobile extends React.Component<
  Props & WithTranslation
> {
  dropdownRef: React.RefObject<any> = React.createRef();
  getItems = () => {
    const {
      t,
      pushBadgeModal,
      pushPointsModal,
      onLlamaBadgeSent,
      onCakeBadgeSent,
      profileOwnerUser: { username, userId },
      giveState,
    } = this.props;

    return [
      {
        label: giveState.canBeGivenCore
          ? t!('navigation.subnavigation.giveCore')
          : t!('navigation.subnavigation.hasCore'),
        onClick: () => window.location.assign(Url.giveCoreMembership(username)),
        disabled: !giveState.canBeGivenCore,
      },
      {
        label: t!('navigation.subnavigation.givePoints'),
        onClick: () => {
          pushPointsModal(username, t!('navigation.subnavigation.givePoints'));
        },
      },
      {
        label: giveState.canBeGivenLlama
          ? t!('navigation.subnavigation.giveLlamaBadge')
          : t!('navigation.subnavigation.hasGotLlamaBadge'),
        onClick: () => {
          const badge = givableBadgeItemsHash.llama;
          pushBadgeModal(
            'llama',
            userId,
            t!('widgets.badgesbox.gift.give', { title: badge.title }),
            onLlamaBadgeSent
          );
        },
        disabled: !giveState.canBeGivenLlama,
      },
      {
        label: giveState.canBeGivenCake
          ? t!('navigation.subnavigation.giveCakeBadge')
          : t!('navigation.subnavigation.hasGotCakeBadge'),
        onClick: () => {
          const badge = givableBadgeItemsHash.cake;
          pushBadgeModal(
            'cake',
            userId,
            t!('widgets.badgesbox.gift.give', { title: badge.title }),
            onCakeBadgeSent
          );
        },
        disabled: !giveState.canBeGivenCake,
      },
    ];
  };

  render() {
    const items = this.getItems();
    const { className, initGiveState } = this.props;

    return (
      <div className={classnames(s['root'], className)}>
        <div className={s['open-btn']}>
          <EllipsisIcon className={this.props.iconClassName} />
        </div>
        <select
          ref={this.dropdownRef}
          onClick={initGiveState}
          onChange={this.handleClick}
          defaultValue="-1"
        >
          <option hidden disabled value="-1" />
          {items.map((item, i) => (
            <option key={i} value={i} disabled={item.disabled}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  handleClick = () => {
    const clickedIndex = this.dropdownRef.current.value;
    const selectedItem = this.getItems()[clickedIndex];
    selectedItem.onClick();
    this.dropdownRef.current.value = '-1';
  };
}

export default withTranslation()(MoreActionsDropdownMobile);
